<div class="row g-3">
  <div class="col-md-12">
    <app-metric-card
      class="coverage-card"
      [title]="'Average Coverage'"
      [currentValue]="emailAverageCoverage()?.average_coverage_percentage ?? 0"
      [previousValue]="emailAverageCoverage()?.average_coverage_percentage_previous ?? 0"
      [valueChange]="emailAverageCoverage()?.average_coverage_percentage_change ?? 0"
      [isHigherBetter]="true"
      [suffix]="'%'"
      [showLeftBorder]="false"
      [showLastUpdated]="false"
    ></app-metric-card>
  </div>
</div>
